import { call, put, take, takeEvery } from 'redux-saga/effects';
import { API } from '@factorin/container.macro';

import { createDownloadChannel, augmentSaga } from 'Modules/core/redux';
import { withErrorHandler } from 'Modules/core/messaging';
import { callApi } from 'Modules/core/api';

import { downloadsActions } from './actions';


function* downloadDocumentWithProgress(path, { method = 'download', id, ...request }) {
    const progressChannel = yield call(
        createDownloadChannel,
        args => callApi(API.domain[path][method], args), {
            id,
            ...request,
            saveAs: `${path}_id${id}`,
        },
    );
    while (true) {
        const { error, done, ...progress } = yield take(progressChannel);
        if (error) {
            yield put(downloadsActions.finish(path, id));
            throw error;
        }

        if (done)
            break;

        yield put(downloadsActions.progress(path, { id, ...progress }));
    }

    yield put(downloadsActions.finish(path, id));
}

function* download({ path, $payload }) {
    yield API.wrap(downloadDocumentWithProgress, path, $payload);
}

export function* initializeState() {
    yield put(downloadsActions.initialize());
}

export const sagas = [
    takeEvery(`${downloadsActions.download}`, augmentSaga(
        download,
        withErrorHandler('downloads.error'),
    )),
];
